import React from 'react';
const AvatarPlaceholder = () => (
	<svg width="68" height="69" viewBox="0 0 68 69" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_9_677)">
			<rect width="68" height="69" rx="34" fill="white" />
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M60.4445 73.3125V66.6042C60.4445 59.1943 54.5247 53.1875 47.2222 53.1875H20.7778C13.4754 53.1875 7.55557 59.1943 7.55557 66.6042V73.3125"
				fill="#888888"
			/>
			<path
				d="M60.4445 73.3125V66.6042C60.4445 59.1943 54.5247 53.1875 47.2222 53.1875H20.7778C13.4754 53.1875 7.55557 59.1943 7.55557 66.6042V73.3125"
				stroke="#888888"
				stroke-width="2.26303"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M34 39.7708C41.3024 39.7708 47.2222 33.764 47.2222 26.3542C47.2222 18.9443 41.3024 12.9375 34 12.9375C26.6976 12.9375 20.7778 18.9443 20.7778 26.3542C20.7778 33.764 26.6976 39.7708 34 39.7708Z"
				fill="#888888"
				stroke="#888888"
				stroke-width="2.26303"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<rect x="1" y="1" width="66" height="67" rx="33" stroke="#888888" stroke-width="2" />
		<defs>
			<clipPath id="clip0_9_677">
				<rect width="68" height="69" rx="34" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export default AvatarPlaceholder;
